import store from '@/store';
import { translate } from '@/translation/native_translate';

export default class Banner {
  static TYPE_UNKNOWN = '';
  static TYPE_UNDER_MAINTENANCE = 'UnderMaintenance';
  static TYPE_POOR_BANDWIDTH = 'PoorBandwidth';
  static TYPE_TMP_MSG = 'TemporaryMessage'; // Used to show a temporary message

  static DEFAULT_ICON_COLOR = 'primary';

  /**
   * Show the banner for a certain type
   * @param { Number } bannerType Type of the banner to be shown.
   * Availabe types: TYPE_UNKNOWN, TYPE_UNDER_MAINTENANCE, TYPE_POOR_BANDWIDTH
   */
  static show(bannerType) {
    console.log(`Received request to show banner with type [${bannerType}]`);
    const typeInStore = store.getters['banner/type'];
    const visibleInStore = store.getters['banner/visible'];

    if (typeInStore === bannerType) {
      // If visibleInStore == true, the same type of banner is visible now. Nothing needs to be done.
      // Else if visibleInStore == false, the same type of banner has already been closed manually by user, do not show it again
      console.log(
        `Banner type [${bannerType}] has already been closed manually by user, or is currently visible, nothing needs to be done.`
      );
      return;
    } else {
      // Wants to show different type, check priority first
      if (typeInStore === Banner.TYPE_UNDER_MAINTENANCE && visibleInStore) {
        // Server maintenance banner is visible now, which has the highest priority.
        console.log(
          `Banner of type [${Banner.TYPE_UNDER_MAINTENANCE}] is currently visible, which has the highest priority. Banner of type [${bannerType}] can not be shown.`
        );
        return;
      }
    }

    let type = Banner.TYPE_UNKNOWN;
    let title = '';
    let message = '';
    let icon = '';
    let iconColor = this.DEFAULT_ICON_COLOR;
    let confirmBtnText = '';

    switch (bannerType) {
      case Banner.TYPE_UNDER_MAINTENANCE:
        type = Banner.TYPE_UNDER_MAINTENANCE;
        title = translate('SERVER_MAINTENANCE_TITLE');
        message = translate('SERVER_MAINTENANCE_MESSAGE');
        icon = 'mdi-alert-outline';
        iconColor = 'error';
        confirmBtnText = '';
        break;
      case Banner.TYPE_POOR_BANDWIDTH:
        type = Banner.TYPE_POOR_BANDWIDTH;
        title = translate('POOR_BANDWIDTH_TITLE');
        message = translate('POOR_BANDWIDTH_MESSAGE');
        icon = 'mdi-alert-outline';
        iconColor = 'error';
        confirmBtnText = '';
        break;
      case Banner.TYPE_TMP_MSG:
        type = Banner.TYPE_TMP_MSG;
        title = translate('HOSTNET_ISSUE_ALERT_TITLE');
        message = translate('HOSTNET_ISSUE_ALERT');
        icon = 'mdi-alert-outline';
        iconColor = 'error';
        confirmBtnText = '';
        break;
      default:
        break;
    }

    if (type !== Banner.TYPE_UNKNOWN) {
      console.log(`Going to show banner with type [${bannerType}]`);
      store.commit('banner/setType', type);
      store.commit('banner/setTitle', title);
      store.commit('banner/setMessage', message);
      store.commit('banner/setIcon', icon);
      store.commit('banner/setIconColor', iconColor);
      store.commit('banner/setConfirmBtnText', confirmBtnText);
      store.commit('banner/setVisibility', true);
    } else {
      console.log(
        `Unknown banner type [${bannerType}]. Going to reset the banner properties.`
      );
      // this.reset();
    }
  }

  /**
   * User manually closes the banner
   */
  static close() {
    // Not clear other properties, especially the type, which can be used for history purpose
    store.commit('banner/setVisibility', false);
  }

  /**
   * Close the banner and reset all properties, which can be used to reset the banner internally
   */
  static reset() {
    store.commit('banner/setVisibility', false);
    store.commit('banner/setType', Banner.TYPE_UNKNOWN);
    store.commit('banner/setTitle', '');
    store.commit('banner/setMessage', '');
    store.commit('banner/setIcon', '');
    store.commit('banner/setIconColor', Banner.DEFAULT_ICON_COLOR);
    store.commit('banner/setConfirmBtnText', '');
  }

  static action1() {
    // TODO: Implement the function for the button click (rename function needed)
  }

  static action2() {
    // TODO: Implement the function for the button click (rename function needed)
  }
}
